<template>
    <vx-select
        style="width: 100px !important"
        label="Page Size"
        v-model="pageSize"
        autocomplete
        :disabled="disabled"
        :options="localOptions"
        :clearable="false"
        remove-validation-padding
    />
</template>

<script>
export default {
    name: 'page-size-select',
    props: {
        value: {
            type: Number,
            default: 15
        },
        disabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultOptions: [10, 15, 50, 100, 200]
        }
    },
    computed: {
        pageSize: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        localOptions() {
            return this.options && this.options.any() ? this.options : this.defaultOptions
        }
    }
}
</script>
